import React, { FunctionComponent } from "react";

import { bemClassNames } from "@multiweb/reactUtils";

const classNames = bemClassNames("dropdown-separator-item");

export const DropdownSeparatorItem: FunctionComponent = (() => <div role="separator" className={classNames()}/>);
